<script>
  export default {
    data() {
      return {
        repaymentPartners: [
          {
            slug: 'intesa',
            url: 'https://elba2.intesasanpaolobanka.ba/front/auth/login/?next=https%3A%2F%2Felba2.intesasanpaolobanka.ba%2Ffront%2Fmain%2Fapp%2F',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'unicredit',
            url: 'https://ba.unicreditbanking.eu/bs/login_form?reload=t',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'addiko',
            url: 'https://ebank.addiko-fbih.ba/',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'raiffeisen',
            url: 'https://rbbhnet.raiffeisenbank.ba/loginchoose/',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'ziraat',
            url: 'https://webebank.ebb.ba/tzbbba_ebank/auth/login',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'sparkasse',
            url: 'https://elba.sparkasse.ba/front/auth/login/?next=https%3A%2F%2Felba.sparkasse.ba%2Ffront%2Fmain%2Fapp%2F',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'asa',
            url: 'https://www.asabanka.ba',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'sberbank',
            url: 'https://e.banka.ba/front/auth/login/?next=https%3A%2F%2Fe.banka.ba%2Ffront%2Fmain%2Fapp%2F',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'nlb',
            url: 'https://webebank.ebb.ba/tbtu_ebank/auth/login',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'bosna',
            url: 'https://e.bbi.ba/prijava.aspx?ReturnUrl=%2f',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          },
          {
            slug: 'privredna',
            url: 'https://elba.pbs.ba/front/auth/login/',
            recommended: false,
            redirect: false,
            iban: '1549212011817146'
          }
        ]
      }
    }
  }
</script>
